<template>
  <mix-list :playlist="playlist" class="mix-list" />
</template>

<script>
import MixList from '../mix_list.vue'
import { playlistStore } from '../path_store'

export default {
  components: { MixList },
  created() {
    playlistStore.init(window.mbPreload?.playlist)
  },
  watch: {
    '$route': {
      handler(to) {
        playlistStore.setPath(to.path)
      },
      immediate: true
    }
  },
  computed: {
    playlist() {
      return playlistStore.items
    }
  }
}
</script>
